import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import './FinanceofficerMenu';

var defaultimage = require('../../assets/img/images.png');



 const FinanceofficerMenu = () => {
    let items: MenuItem[] = [
        {
            label: 'Applications',icon: '', url: '/medi/fpapplications'
        },
        {
            label: 'Activities', icon: '', url: '/medi/fiofnactivities'
        },





    ];
    const handleItemClick = (event: { item: { url: string } }) => {
      if (event.item.url) {
          window.location.href = event.item.url;
      }
  };

    return (
        <aside className="main-sidebar">
        {/* <div className="user-info" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={photo || defaultimage} className="avatar" alt="User Image" />
          <h2 style={{ color: 'rgb(255, 255, 255)', fontSize: '22px', fontWeight: '700', marginLeft: '10px' }}>
            {name}
          </h2>
        </div> */}
        <div className="menu" >
          <div className="menu-container" style={{margin:'0px 10px'}}>
            <PanelMenu model={items} style={{ width: '980px', textAlign: 'center',backgroundColor:'#fff' }} />
            {/* <PanelMenu model={items} onClick={() => handleItemClick} style={{width:'980px',textAlign:'center'}} />  */}

          </div>
        </div>
      </aside>
      
    );
};
export default FinanceofficerMenu;
